

export function column3_dblClick(event) {
	//Add your code for this event here: 
}